import React from 'react'
import Button from '@groovehq/internal-design-system/lib/components/Button/Button'
import { useDrawer } from 'ducks/drawers/hooks'
import { DRAWER_TYPE_ONBOARDING_WORKFLOW } from 'ducks/drawers/types'
import inbox from 'assets/inbox_empty.png'
import { styles } from './styles'

const OnboardingWorkflowCard = ({ mini = false, className }) => {
  const { openDrawer: openOnboardingWorkflow } = useDrawer({
    type: DRAWER_TYPE_ONBOARDING_WORKFLOW,
  })

  return (
    <div
      css={[styles.positionBase, mini ? styles.positionMini : styles.position]}
      className={className}
    >
      <div
        css={[
          styles.containerBase,
          mini ? styles.containerMini : styles.container,
        ]}
      >
        <div className="grui flex">
          <div css={mini ? styles.contentMini : styles.content}>
            <h2 className="grui">Get your email flowing into Groove!</h2>
            <p className="grui">Setup time of 2 minutes or less</p>
            <Button type="info" size="xBig" onClick={openOnboardingWorkflow}>
              <span aria-hidden="true">📨</span>
              Lets get started!
            </Button>
          </div>
          {!mini && (
            <div className="grui flex flex-grow">
              <img
                src={inbox}
                aria-hidden="true"
                alt=""
                width="429"
                height="337"
                css={styles.image}
              />
            </div>
          )}
        </div>
      </div>
    </div>
  )
}

export default OnboardingWorkflowCard
